import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removePartnerGroupChannelMember } from '../services/partnerGroupChannel';
import { partnerGroupChannelQueryKeys } from './use-partner-group-channel-query';

export const useRemovePartnerGroupChannelMemberMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ memberId }) => {
      if (!memberId) {
        throw new Error('Member id is required to block a community member.');
      }

      const result = await removePartnerGroupChannelMember(memberId);

      if (!result.success) {
        throw new Error(result.message || 'Failed to remove community member');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: partnerGroupChannelQueryKeys.all });
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};

export default useRemovePartnerGroupChannelMemberMutation;
